import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
import { getGalleryInner } from "../Service/Api";

const S3_url = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com";

const MunGallery = ({ items }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeYear, setActiveYear] = useState("");
  const [yearTabs, setYearTabs] = useState([]);

  const fallbackItems = [
    { title: "NCS MUN", attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"] },
    { title: "Debate Room", attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"] },
    { title: "Conference Hall", attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"] },
    { title: "Delegate View", attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"] },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        let galleryItems = Array.isArray(items) ? items : [];

        if (galleryItems.length === 0) {
          const galleryData = await getGalleryInner();
          galleryItems = galleryData.filter((item) => item.category === "NcsMUN");
        }

        const sortedItems = [...galleryItems].sort((a, b) => new Date(b.date) - new Date(a.date));
        const itemsWithDate = sortedItems.filter((item) => item.date);

        if (itemsWithDate.length > 0) {
          const foundYears = Array.from(
            new Set(itemsWithDate.map((item) => String(new Date(item.date).getFullYear())))
          ).sort((a, b) => Number(b) - Number(a));

          setYearTabs(foundYears);
          setActiveYear(foundYears[0] || "");
          setData(itemsWithDate);
        } else {
          setYearTabs([]);
          setActiveYear("");
          setData(sortedItems.length > 0 ? sortedItems : fallbackItems);
        }
      } catch (error) {
        console.error("Error fetching MUN gallery data:", error);
        setYearTabs([]);
        setActiveYear("");
        setData(fallbackItems);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const visibleItems = (() => {
    const sourceItems = loading ? fallbackItems : data;

    if (!yearTabs.length || !activeYear) {
      return sourceItems;
    }

    return sourceItems.filter((item) => String(new Date(item.date).getFullYear()) === activeYear);
  })();

  return (
    <div className="mun-gallery-wrap">
      {yearTabs.length > 0 && (
        <div className="mun-year-tabs" role="tablist" aria-label="MUN gallery years">
          {yearTabs.map((year) => (
            <button
              key={year}
              type="button"
              className={`mun-year-tab${activeYear === year ? " is-active" : ""}`}
              onClick={() => setActiveYear(year)}
            >
              {year}
            </button>
          ))}
        </div>
      )}
      <div className="row">
        <Slider {...settings}>
          {visibleItems.map((item, index) => (
            <div className="item" key={item._id || item.title || index}>
              <div className="gallery-item">
                <div className="project-thumb gal-big">
                
                 
                      <img
                        src={`${S3_url}/${item.attachments?.[0]}`}
                        alt={item.title || "NCS MUN"}
                        className="img-fluid"
                      />
                    
               
                </div>
                <div className="project-content">
                  <h2 className="title">{item.title}</h2>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <div className="mun-view-all-wrap" >
        <Link className="mun-view-all-btn" to="/ncs-mun-gallery" style={{margin: 'auto'}}>
          View All
        </Link>
      </div>
    </div>
  );
};

export default MunGallery;
